import type { ComparisonBlockView } from "../../../../clients/Purchaser/Compare.ts";
import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";

export default function GenericBlock(params: { block: ComparisonBlockView }) {
    return (
        <div>
            <h1 className="mb-4 text-xl font-bold">{params.block.type}</h1>
            {params.block.content ? (
                <Markdown remarkPlugins={[remarkGfm]} skipHtml={true}>
                    {params.block.content}
                </Markdown>
            ) : (
                <div className="flex flex-col space-y-2">
                    <div className="h-6 animate-pulse bg-stone-100" />
                    <div className="h-6 animate-pulse bg-stone-100" />
                    <div className="h-6 animate-pulse bg-stone-100" />
                    <div className="h-6 w-3/4 animate-pulse bg-stone-100" />
                </div>
            )}
        </div>
    );
}
